module.exports = __webpack_public_path__ + "static/img/MU.1084318f.jpg";